import { ImageProps } from '@design-system/image';
import { MediaPlusTextProps, MediaType } from '@design-system/media-plus-text';
import { ExtendableElement } from '@design-system/types';

import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { imageMapper } from '~/mappers/image/imageMapper';
import { pageBlockMapper } from '~/mappers/pageBlock';

import { videoMapper } from '../video';
import { Video } from '../video/models';
import { ImageModel, MapperType, MediaPlusTextBlock } from './models';

export const mediaPlusTextBlockMapper = ({
  media: [media],
  content,
  pageBlock,
  ctaBlocks,
  align,
  mediaWidth,
  mediaPosition,
}: MediaPlusTextBlock): MediaPlusTextProps => {
  const mappers:
    | MapperType<'Contentstack_image_model'>
    | MapperType<'Contentstack_video'> = {
    Contentstack_image_model: (m: ImageModel) => ({
      media: { image: imageMapper(m.image) as ExtendableElement<ImageProps> },
      mediaType: MediaType.Image,
    }),
    Contentstack_video: (m: Video) => ({
      media: videoMapper(m),
      mediaType: MediaType.Video,
    }),
  };

  return {
    ...(pageBlock && { pageBlock: pageBlockMapper(pageBlock) }),
    ...mappers[media.typeName](media),
    mediaWidth,
    ...(content && { content }),
    ...(ctaBlocks?.ctaBlocks.length && {
      ctaBlock: ctaBlockMapper(ctaBlocks.ctaBlocks),
    }),
    mediaPosition,
    align,
  } as MediaPlusTextProps;
};
